import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import NoLongerAtRiskForm from '../../../../accs/form/no-longer-at-risk'


const formValue = 'no_longer_at_risk'

const available = (record) => hasAvailableAction(record, 'no_longer_at_risk')

const calculateSubmitValues = (values) => {
  const record_key = values.type === 'DETERMINATION'
    ? 'determination_id'
    : 'certificate_id'

  let submitValues = { 
    ...values,
    evidence: values.evidence.map((item) => {
      item['id'] = values.gov_id
      return item
    }),
    [record_key]: values.gov_id
  }

  delete submitValues.gov_id

  return submitValues
}

const defaultValues = (record) => {
  return {
    type: record.type,
    gov_id: record.gov_id,
    declaration_given: null,
    risk_reason: '',
    date_no_longer_risk: '',
    record_support_risk: null,
    evidence: []
  }
}

const actionForm = ({ regHolderId, record }) => ({ handleSuccess }) => {
  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/accs/no-longer-risk`
      }
      name={formValue}
      label='Child No Longer At Risk'
      calculateSubmitValues={calculateSubmitValues}
      handleSuccess={() =>
        handleSuccess({ [formValue]: 'Child No Longer At Risk.' }, formValue)
      }
      formOptions={{ defaultValues: defaultValues(record) }}
      formComponent={(props) => (
        <NoLongerAtRiskForm {...props} required={false} hasType={true} />
      )}
    />
  )
}

export const childNoLongerAtRisk = ({
  regHolderId,
  record,
  refresh_accs_gov_enrolments
}) => {
  return available(record)
    ? {
      label: 'Child No Longer At Risk',
      value: 'child_no_longer_at_risk',
      actionForm: actionForm({ record, regHolderId }),
      onCompletePreserveAction: true,
      onComplete: refresh_accs_gov_enrolments
    } : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/mark-no-longer-at-risk/index.js